import { useTranslation } from 'react-i18next';
import { DeliveryOptionLabels } from '../../../models/delivery-options/common';
import { DeliveryOptionRibbonLabel } from './delivery-option-card-label.styles';

interface DeliveryOptionCardLabelProps {
  type: DeliveryOptionLabels;
  order: number;
}

interface DeliveryOptionCardLabelConfig {
  color: string;
  translationKey: string;
}

const config: Record<DeliveryOptionLabels, DeliveryOptionCardLabelConfig> = {
  optimal: {
    color: '#FFBE0A',
    translationKey: 'delivery_options_label_optimal',
  },
  popular: {
    color: '#008CFF',
    translationKey: 'delivery_options_label_popular',
  },
  bestprice: {
    color: '#47CE72',
    translationKey: 'delivery_options_label_best_price',
  },
  fastest: {
    color: '#ED5576',
    translationKey: 'delivery_options_label_fastest',
  },
};

const DeliveryOptionCardLabel = ({
  type,
  order,
}: DeliveryOptionCardLabelProps) => {
  const { t } = useTranslation();
  const labelConfig = config[type];

  return (
    <DeliveryOptionRibbonLabel
      $bgColor={labelConfig.color}
      $order={order}>
      {t(labelConfig.translationKey)}
    </DeliveryOptionRibbonLabel>
  );
};

export default DeliveryOptionCardLabel;
